<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="TOKEN：" prop="token">
                <el-input v-model="model.token"></el-input>
                <span class="tips">请以“HT”开头</span>
            </el-form-item>
            <el-form-item label="验证码：" prop="yzm">
                <el-input v-model="model.yzm"></el-input>
                <span class="tips">建议为6位数字</span>
            </el-form-item>
            <el-form-item label="充值号：" prop="recharge_sn">
                <el-input v-model="model.recharge_sn"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'mdhzEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                token: '',
                yzm: '',
                vid: '',
                member_id: '',
                car_info_id: '',
                state: '',
                add_time: '',
                bind_time: '',
            },
            getObj:{
                url:'/api/admin/mdhz/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            exits_p_name:'token',
            exits_p_title:'TOKEN',
            checkObj:{
                url:'/api/admin/mdhz/check',
                data:{}
            },
            rules: {
                token: [
                    {required: true, message: 'TOKEN不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                yzm: [
                    {required: true, message: '验证码不能为空', trigger: 'blur'},
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/mdhz/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>